export const MARKETPLACE_ICONS = {
  leroymerlin: '/icons/logo-leroymerlin.svg',
  shoppingfeed: '/icons/default_mp_icon.svg',
  castorama: '/icons/default_mp_icon.svg',
  but: '/icons/default_mp_icon.svg',
  maxeda: '/icons/default_mp_icon.svg',
  conforama: '/icons/default_mp_icon.svg',
  xxxlutz: '/icons/default_mp_icon.svg',
  hornbach: '/icons/default_mp_icon.svg',
  leclerc: '/icons/default_mp_icon.svg',
  worten: '/icons/default_mp_icon.svg',
  bricodepot: '/icons/default_mp_icon.svg',
  home24: '/icons/default_mp_icon.svg',
};

export const getMarketplaceIcon = (marketplaceName) => {
  return MARKETPLACE_ICONS[marketplaceName] || '/icons/default_mp_icon.svg';
};
